import { NavLink } from 'react-router-dom';
import styles from './Navigation.module.css';

export function Navigation() {
  return (
    <header className={styles.header}>
      <div className={styles.brand}>
        <div className={styles.brandIcon}>
          <svg viewBox="0 0 24 24" fill="none" width="26" height="26">
            <defs>
              <filter id="phosphorGlow">
                <feGaussianBlur stdDeviation="1.4" result="blur" />
                <feComposite in="SourceGraphic" in2="blur" operator="over" />
              </filter>
            </defs>
            <rect x="4" y="3" width="4" height="18" rx="0.5" fill="#CC3030" filter="url(#phosphorGlow)" />
            <rect x="10" y="3" width="4" height="18" rx="0.5" fill="#20CC38" filter="url(#phosphorGlow)" />
            <rect x="16" y="3" width="4" height="18" rx="0.5" fill="#4488FF" filter="url(#phosphorGlow)" />
          </svg>
        </div>
        <span className={styles.brandName}>Creative Converters</span>
      </div>

      <nav className={styles.nav} aria-label="Converters">
        <NavLink
          to="/lut"
          className={({ isActive }) => `${styles.navLink} ${isActive ? styles.navLinkActive : ''}`.trim()}
        >
          LUT Converter
        </NavLink>
      </nav>
    </header>
  );
}

export default Navigation;
